import { render, staticRenderFns } from "./sorting_print.vue?vue&type=template&id=1d19d6e2&scoped=true&"
import script from "./sorting_print.vue?vue&type=script&lang=js&"
export * from "./sorting_print.vue?vue&type=script&lang=js&"
import style0 from "./sorting_print.vue?vue&type=style&index=0&id=1d19d6e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d19d6e2",
  null
  
)

export default component.exports